import { useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_PATHMATICS_MARK_AS_INVALID } from "../../routes";
import { debug } from "../../utils/helpers";

export function useMarkAsInvalid() {
  const [isLoading, setIsLoading] = useState(false);

  const markAsInvalid = (payload = []) => {
    setIsLoading(true);

    return Api.post(API_ROUTE_PATHMATICS_MARK_AS_INVALID, payload)
      .catch((error) => {
        debug.log(error);
        return Promise.reject(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    isLoading,
    markAsInvalid,
  };
}
